import type { ComponentPropsWithRef, ReactNode } from "react";
import { forwardRef } from "react";
import { BlockSection } from "@/react/components/shared/BuilderUI/BlockSection";
import { primaryBlockDefaultStyles } from "@/react/components/shared/BuilderUI/DefaultBlocks/Homepage/constants";
import { useTopBlockStyles } from "@/react/components/shared/BuilderUI/Hooks/useTopBlockStyles";
import type { StyleValue } from "@/react/components/shared/BuilderUI/StyleValue.types";

export interface TestimonialsBlock1Props
  extends Omit<ComponentPropsWithRef<"div">, "content"> {
  content: ReactNode;
  styles?: Record<string, StyleValue>;
}

export const TestimonialsBlock1 = forwardRef<
  HTMLDivElement,
  TestimonialsBlock1Props
>(({ content, className, styles, ...rest }, ref) => {
  const { backgroundStyles, paddingStyles, marginStyles } = useTopBlockStyles({
    styles,
    defaultStyles: primaryBlockDefaultStyles,
  });

  return (
    <BlockSection ref={ref} className={className} {...rest}>
      <BlockSection.Background style={backgroundStyles}>
        <BlockSection.Container>
          <BlockSection.Content
            style={{
              ...paddingStyles,
              ...marginStyles,
            }}
          >
            <BlockSection.NestedBlock className="wb-flex wb-flex-col wb-items-center wb-text-center wb-gap-6 wb-max-w-2xl wb-mx-auto">
              {content}
            </BlockSection.NestedBlock>
          </BlockSection.Content>
        </BlockSection.Container>
      </BlockSection.Background>
    </BlockSection>
  );
});

TestimonialsBlock1.displayName = "TestimonialsBlock1";
